import React from 'react';
import Box from './Box';
import TextField from '@material-ui/core/TextField';
import validar from './validar';
/*
 * getValue: função para obter valor pela key (name)
 * getError: função para obter erro pela key (name)
 * name: key que identifica o campo
 * label: label do campo no formulário
 * setValue: função para alterar campos no estado, recebe como parametro a key (name)
 * setError: função para informar erro, recebe os parametros name e message, se message for false é considerado sem erro
 * setTouch: função para informar que campo foi acessado, é executado no onBlur. Considerado para realização da validação 'on-the-fly'
 * valida: função para validar o input do usuário. Recebe o valor, se validação for ok retorna null, se der erro retorna a mensagem.
 * wasTouched: função que confere se o campo já foi acessado, recebe a key (name) como parametro
 */

export default function Field (props) {
  const { getValue, getError, name, label, setValue, setError, setTouch, valida, wasTouched } = props;
  const value = getValue(name);
  const error = getError(name);
  const hasError = Boolean(error);
  if (valida) validar({ name, valida, value, setError, wasTouched, hasError })
  const p = hasError ? { error: true, helperText: error } : {}
  return (
    <Box id={name}>
      <TextField
        fullWidth
        onBlur={setTouch(name)}
        label={label}
        value={value}
        onChange={setValue(name)}
        {...p}
      />
    </Box>
  )
}
